import { mainAPIUrl } from '../../../settings';

const baseURL = `${mainAPIUrl}/gservices_3/ss`;

/**
 * Verify the SMS code sent to the user's phone
 * Endpoint: POST /gservices_3/ss/smartsend/verify_sms
 *
 * @param {string} orderId - The order ID
 * @param {string} phoneNumber - Phone number in E.164 format (e.g., "+14155552671")
 * @param {string} code - 6-digit verification code
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export const verifyCode = async (orderId, phoneNumber, code) => {
  try {
    const url = `${baseURL}/smartsend/verify_sms`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        orderId,
        phoneNumber,
        verificationCode: code
      })
    });

    const json = await response.json();

    // Success response
    if (response.ok && json.code === 'SUCCESS') {
      return {
        success: true
      };
    }

    // Handle specific error codes
    const errorMessages = {
      VERIFICATION_ERR: 'Invalid verification code. Please try again.',
      ORDER_NOT_FOUND: 'Unable to process this request. Please try again.',
      ORDER_INVALID_STATE: 'This order has already been processed.',
      INVALID_PHONE: 'Invalid phone number. Please check the number and try again.',
      PHONE_FORMAT: 'Invalid phone number format.',
      USER_CREATION_FAILED: 'Unable to verify your account. Please try again.',
      MISSING_PARAMS: 'Missing required information.',
      SERVER_ERROR: 'Something went wrong. Please try again.'
    };

    return {
      success: false,
      error: errorMessages[json.code] || json.message || 'Verification failed. Please try again.'
    };
  } catch (error) {
    console.error('Error verifying code:', error);
    return {
      success: false,
      error: 'Network error. Please check your connection and try again.'
    };
  }
};
